export default __webpack_public_path__ + "2f80bc76bc462ed1134b5d1cfd458411.png";